import { gql } from '__generated__';

export default gql(`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`);
